export default (err)=> {
	if (window && window.ga && ["Error: Network Error", "Network Error"].indexOf(err.message) === -1 && err.filename) {
		window.ga('send', 'exception', {
			'exDescription': `${err.message} (${err.filename}:${err.lineno}:${err.colno})`
		});
	}
};